'use client'
import type { Data } from '@repo/strapi'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { BannerCard } from '@/components/shared/BannerCard'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/styles'
import type { ServerRenderedEntry } from '@/types/helpers'
import { getColsValue } from '@/utils/colsMapping'

export function CardsBannerContent({
	cards,
	showMoreAfterCount,
	bgClassName,
	disableBannerLayout,
	columns,
}: {
	readonly cards?: ServerRenderedEntry<Data.Component<'shared.banner-card'>>[] | null
	readonly showMoreAfterCount?: number | null
	readonly bgClassName?: string | null
	readonly disableBannerLayout?: boolean | null
	readonly columns?: Data.Component<'enums.columns'> | null
}) {
	const t = useTranslations('buttons')
	const sliceAfter = showMoreAfterCount ?? cards?.length ?? 0
	const [showMore, setShowMore] = useState(false)
	return Array.isArray(cards) && cards.length > 0 ? (
		<>
			<div className={cn('grid gap-3 lg:gap-4', getColsValue(columns?.column))}>
				{cards?.slice(0, showMore ? cards?.length : sliceAfter)?.map((card) => (
					<BannerCard
						key={card.id}
						card={card}
						cardBackgroundColorVariant={disableBannerLayout ? bgClassName : 'bg-neutral-light-100'}
					/>
				))}
			</div>

			{cards?.length > sliceAfter && (
				<div className="flex w-full justify-center items-baseline">
					<Button variant="primary" size="large" onClick={() => setShowMore(!showMore)}>
						{showMore ? t('showLess') : t('showMore')}
					</Button>
				</div>
			)}
		</>
	) : null
}

export default CardsBannerContent
